import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getRatingsHandler, { IRankItem, RatingType } from "./get-ratings.handler";

export interface IRatingsState extends IRequestState {
    current: RatingType | null;
    users: IRankItem[],
};

const initialState: IRatingsState = {
    current: RatingType.Experience,
    users: [],
    
    loading: false,
    error: "",
};

const ratingsSlice = createSlice({
    name: 'ratings',
    initialState,
    reducers: {
        setCurrentRating: (state, action: PayloadAction<RatingType>) => {
            state.current = action.payload;
        }
    },
    extraReducers: (builder: ActionReducerMapBuilder<IRatingsState>) => {
        getRatingsHandler(builder);
    },
});

export default ratingsSlice.reducer;
export const { setCurrentRating } = ratingsSlice.actions;